import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { FaWallet, FaCog, FaSignOutAlt, FaRupeeSign, FaCreditCard } from "react-icons/fa";

const InfluenerHeader = ({ isProfileComplete, onLogout }) => {
  const navigate = useNavigate();
  const [balance, setBalance] = useState(null);

  useEffect(() => {
    const fetchBalance = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/get/wallet/detail`,
          { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
        );
        setBalance(response.data.balance || 0);
      } catch (err) {
        console.error("Failed to fetch balance:", err);
      }
    };
    fetchBalance();
  }, []);

  return (
    <header className="influencer-header bg-white/90 backdrop-blur-xl sticky top-0 z-30 h-16 border-b border-slate-200/60 flex items-center justify-between px-4 sm:px-8">
      <div className="flex items-center gap-4">
        {/* Profile Completion Indicator - Hidden on mobile to avoid clash with menu button */}
        <div className="hidden md:flex items-center gap-2 px-3 py-1.5 rounded-full bg-slate-50 border border-slate-100 shadow-sm transition-all hover:border-purple-200">
          <div className={`w-2 h-2 rounded-full ${isProfileComplete ? 'bg-emerald-500' : 'bg-amber-500 animate-pulse'}`} />
          <span className="text-[10px] font-black uppercase tracking-widest text-slate-500">
            {isProfileComplete ? 'Identity Verified' : 'Action Required'}
          </span>
        </div>
      </div>

      <div className="flex items-center gap-2 sm:gap-4">
        {/* Wallet Balance - Premium Design */}
        <button
          onClick={() => navigate('/influencer/wallet')}
          className="group flex items-center gap-3 px-3 py-1.5 rounded-2xl bg-purple-50 hover:bg-purple-100 border border-purple-100 transition-all active:scale-95 shadow-sm"
          title="Creator Wallet"
        >
          <div className="w-8 h-8 rounded-xl bg-purple-600 shadow-[0_4px_12px_rgba(147,51,234,0.3)] text-white flex items-center justify-center group-hover:scale-110 transition-transform">
            <FaWallet className="w-3.5 h-3.5" />
          </div>
          <div className="flex flex-col items-start leading-none">
            <span className="text-[7px] font-black text-purple-400 uppercase tracking-widest mb-0.5">Balance</span>
            <span className="text-xs font-black text-slate-900 flex items-center">
              <FaRupeeSign className="w-2 h-2 mr-0.5 text-purple-600" />
              {balance !== null ? balance.toLocaleString('en-IN', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) : '...'}
            </span>
          </div>
        </button>

        <div className="h-8 w-[1px] bg-slate-200/60 mx-1 hidden sm:block" />

        <div className="flex items-center gap-1 sm:gap-2">
          {/* Quick Access Card */}
          <button
            onClick={() => navigate('/influencer/id-card')}
            className="p-2.5 text-slate-400 hover:text-purple-600 hover:bg-purple-50 rounded-xl transition-all relative group"
            title="View Official Card"
          >
            <FaCreditCard className="w-4.5 h-4.5 group-hover:scale-110 transition-transform" />
          </button>

          {/* Secure Settings */}
          <button
            onClick={() => navigate('/influencer/changepassword')}
            className="p-2.5 text-slate-400 hover:text-purple-600 hover:bg-purple-50 rounded-xl transition-all group"
            title="Security Settings"
          >
            <FaCog className="w-4.5 h-4.5 group-hover:rotate-90 transition-transform duration-500" />
          </button>

          {/* Logout (Mobile Only) - Professional Red */}
          <button
            onClick={onLogout}
            className="lg:hidden p-2.5 text-rose-500 hover:bg-rose-50 rounded-xl transition-all active:scale-90"
            title="Secure Sign Out"
          >
            <FaSignOutAlt className="w-5 h-5" />
          </button>
        </div>
      </div>
    </header>
  );
};

export default InfluenerHeader;
